import React from "react";

export type AppContextType = {
  theme: {
    isDark: boolean;
  };
};

export const defaultAppState: AppContextType = {
  theme: {
    isDark: true,
  },
};

export interface IAppContext {
  appState: AppContextType;
  setDarkMode: (isDark: boolean) => void;
}

const AppContext = React.createContext<IAppContext>({
  appState: defaultAppState,
  setDarkMode: () => null,
});

export default AppContext;
